import React from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useTheme,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Member from "./Member/Member";

const useStyles = makeStyles()((theme) => ({
  tableContainer: {
    width: "100%",
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
  },

  tableCell: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

function Results({ users, handleUpdateUser, handleDeleteUser, roles, selectedUser, handleSelectUser }) {
  const { classes } = useStyles();
  const theme = useTheme();
  return (
    <TableContainer className={classes.tableContainer}>
      <Table>
        <TableHead sx={{ backgroundColor: theme.palette.background.light }}>
          <TableRow>
            <TableCell className={classes.tableCell} style={{ minWidth: 400, maxWidth: 500 }}>Name</TableCell>
            <TableCell className={classes.tableCell}>Plant</TableCell>
            <TableCell className={classes.tableCell}>Line</TableCell>
            <TableCell className={classes.tableCell}>Role</TableCell>
            <TableCell className={classes.tableCell}>Account Status</TableCell>
            <TableCell className={classes.tableCell} align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <Member
              key={user.id}
              user={user}
              handleUpdateUser={handleUpdateUser}
              handleDeleteUser={handleDeleteUser}
              roles={roles}
              selectedUser={selectedUser}
              handleSelectUser={handleSelectUser}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default Results;
